// extracted by mini-css-extract-plugin
export const hero = "landing-module--hero--18Eto";
export const content = "landing-module--content--11Dd9";
export const textContent = "landing-module--textContent--1pQxy";
export const bio = "landing-module--bio--2xdeo";
export const buttons = "landing-module--buttons--od8id";